export const pelangganJenisFormData = () => {
    return [
        {
            id: "jenis_pelanggan",
            label: "Jenis Pelanggan",
            fields: [{
                type: "input",
                placeholder: "Masukan Nama Jenis Pelanggan"
            }]
        }
    ]
}